import { t } from '@/init'
import { isSafari } from '@/utils'

export default {
  inject: ['getNode', 'getGraph'],
  data() {
    return {
      node: null,
      data: null,
      key: Date.now().toString(),
      nodeStyle: {},
      labelStyle: {},
      tipStyle: {},
      taskStyle: {},
    }
  },
  computed: {
    label() {
      return this.data?.label
    },
    predict() {
      return !!this.data?.predictNode
    },
  },
  mounted() {
    const node = this.getNode()

    if (node) {
      this.node = node
      const {
        store: { data },
      } = node

      this.data = data.data
    }

    if (isSafari) {
      this.initStyle()
    }
  },
  methods: {
    updateComp() {
      this.key = Date.now().toString()
    },
    t,
    initStyle() {
      const handleScale = (scale = 1) => {
        this.nodeStyle = {
          position: 'fixed !important',
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
          width: '100%',
          height: '100%',
        }

        this.labelStyle = {
          position: 'fixed !important',
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
          left: '0',
          width: '100%',
        }

        this.tipStyle = {
          position: 'fixed !important',
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
        }

        this.taskStyle = {
          position: 'fixed !important',
          transform: `scale(${scale}) translate(-50%, 0)`,
          transformOrigin: `0 0`,
          bottom: '-10%',
          left: '50%',
        }
      }

      handleScale()

      const graph = this.getGraph()

      graph.on('scale', ({ sx }) => handleScale(sx))
    },
  },
}
